import React from "react";
import { CheckCircle2, Settings, Palette, Building2, ArrowRightLeft } from "lucide-react";
import { useEnhancedTranslation } from "@/hooks/useEnhancedTranslation";

export function WelcomeStep() {
  const { t } = useEnhancedTranslation();

  const settingsItems = [
    {
      icon: Settings,
      titleKey: "setupGuide.welcome.settingsCategories",
      titleDefault: "Categories & Contract Types",
      descKey: "setupGuide.welcome.settingsCategoriesDesc",
      descDefault: "Customize in Settings → Categories / Contract Types",
    },
    {
      icon: ArrowRightLeft,
      titleKey: "setupGuide.welcome.settingsExchangeRates",
      titleDefault: "Exchange Rates",
      descKey: "setupGuide.welcome.settingsExchangeRatesDesc",
      descDefault: "Manage in Settings → Exchange Rates",
    },
    {
      icon: Building2,
      titleKey: "setupGuide.welcome.settingsCompanyRegister",
      titleDefault: "Company Register",
      descKey: "setupGuide.welcome.settingsCompanyRegisterDesc",
      descDefault: "Configure in Settings → Company Register",
    },
    {
      icon: Palette,
      titleKey: "setupGuide.welcome.settingsColors",
      titleDefault: "Importance & Status Colors",
      descKey: "setupGuide.welcome.settingsColorsDesc",
      descDefault: "Personalize in Settings → Colors",
    },
  ];

  return (
    <div className="space-y-5">
      <div className="flex justify-center mb-3">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <CheckCircle2 className="h-7 w-7 text-primary" />
        </div>
      </div>
      
      <h2 className="text-xl font-semibold text-center">
        {t("setupGuide.welcome.title", "Welcome to Subtrackr")}
      </h2>
      
      <p className="text-center text-muted-foreground text-sm">
        {t("setupGuide.welcome.readyToGo", "Your account is ready to go! We've set up default categories, contract types, and currencies for you.")}
      </p>

      <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
        <h4 className="font-medium text-sm mb-3">
          {t("setupGuide.welcome.customizeTitle", "Want to customize? Here's where to find everything:")}
        </h4>
        <div className="space-y-3">
          {settingsItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="flex items-start gap-3">
                <Icon className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                <div>
                  <p className="text-sm font-medium">{t(item.titleKey, item.titleDefault)}</p>
                  <p className="text-xs text-muted-foreground">{t(item.descKey, item.descDefault)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      <p className="text-xs text-muted-foreground text-center">
        {t("setupGuide.welcome.nextStepHint", "Next, let's set your preferred default currency.")}
      </p>
    </div>
  );
}
